<div
  class="mat-pointer-events-none overlay"
  [style.background-image]="'url(' + url + ')'"
  [style.background-size]="backgroundSize"
></div>
